import { RefObject, useEffect } from 'react';

import { useRouterActions } from 'react-resource-router';

export const useClientSideLinking = (containerRef: RefObject<HTMLElement>) => {
  const { push } = useRouterActions();

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      // Only links that point to pull requests (internal)
      const links = container.querySelectorAll('a.ap-connect-link');

      const clientSideLink = (e: MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        // We can always expect 'href' attribute to be populated based
        // on rendering logic of commit summary
        const el = e.currentTarget as HTMLAnchorElement;
        push(el.getAttribute('href') || '');
      };

      links.forEach((link: HTMLAnchorElement) => {
        link.addEventListener('click', clientSideLink);
      });

      return () => {
        links.forEach((link: HTMLAnchorElement) => {
          link.removeEventListener('click', clientSideLink);
        });
      };
    }

    return () => {};
  }, [containerRef, push]);
};
